// API path constants
export const AUTH_PATH = 'auth'
export const COMPANY_PATH = 'company'
export const SLACK_PATH = 'slack'
export const CONTACT_PATH = 'contact'

// Resource constants
export const LOGOUT_RESOURCE = 'logout'
